<template>
  <div class="container">
    <nav-bar :from="{ name: 'Home' }">补票</nav-bar>
    <div class="tip">
      提示：请核对清楚所在车辆车牌。支付完成后不能取消或更改行程，请知悉！
    </div>

    <div class="box">
      <div class="item">
        <div class="label">所在区域</div>
        <div class="right" :class="{ gray2: !baseLineName }">
          {{ baseLineName ? baseLineName : '暂无可用区域' }}
        </div>
      </div>
      <BusSelector
        v-model="busIndex"
        :columns="busList"
        :disabled="!baseLineId || isFromQr"
        @confirm="onBusOk"
      >
        <div class="item">
          <div class="label">乘坐车辆</div>
          <div class="right">
            <div :class="{ gray: !busLicense }">
              {{ busLicense ? busLicense : '请选择车辆' }}
            </div>
            <img v-if="!isFromQr" src="../../assets/img/arrow-right.png" class="arrow" />
          </div>
        </div>
      </BusSelector>
  
      <div class="item">
        <div class="label">上车点</div>
        <div class="right" :class="{ gray: !onStopName }">
          {{ onStopName ? onStopName : '暂无可用站点' }}
        </div>
      </div>
  
      <div class="item" @click="onOffPoiClick">
        <div class="label">下车点</div>
        <div class="right">
          <div class="name" :class="{ gray: !offStop }">
            {{ offStop ? offStop.name : '输入您的目的地' }}
          </div>
          <img src="../../assets/img/arrow-right.png" class="arrow" />
        </div>
      </div>
  
      <PassengerSelector
        v-model="passengerIndex"
        :columns="passengerPickerData"
        :disabled="!baseLineId"
        @confirm="onPassengerOk"
      >
        <div class="item">
          <div class="label">乘车人数</div>
          <div class="right">
            <div>{{ passengerPickerData[passengerIndex] ? passengerPickerData[passengerIndex].label: '' }}</div>
            <img src="../../assets/img/arrow-right.png" class="arrow" />
          </div>
        </div>
      </PassengerSelector>
    </div>

    <div class="bottom">
      <VanButton v-if="isProtocol" class="submit" @click="onClickSubmit">
        下单
      </VanButton>
      <VanButton class="submit disabled" v-else @click="onClickSubmitDisabled">
        下单
      </VanButton>
      <ProtocolSelector
        v-model="isProtocol"
        :ticketConfig="ticketConfig"
      />
    </div>
    <CashCardPopup v-model="cashCardVisible">
      <CashCard
        v-if="cashCardVisible"
        :coupons="couponList"
        :cashParams="cashParams"
        :isChartered="isChartered"
        :groupPrice="currentArea.groupPrice"
        @onChoose="onChooseCoupon"
        @onOrder="onConfirmOrder"
        @useCouponFail="useCouponFail"
      />
    </CashCardPopup>
  </div>
</template>

<script>
import NavBar from '../../components/nav-bar/index'
import ProtocolSelector from '../home-v2/components/ProtocolSelector.vue'
import BusSelector from './components/BusSelector.vue'
import PassengerSelector from '../home-v2/components/PassengerSelector.vue'
import CashCardPopup from '../home-v2/components/CashCardPopup.vue'
import CashCard from '../home-v2/components/CashCard.vue'
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
import { mapGetters } from 'vuex'
import { wait, getPayType, marsToBaidu, getUrlParams, baiduToMars, deepCopy } from '../../utils'
import { getNearStopAndBus, getConfig } from './service'
import { getValidCoupons } from '../coupon/mgr/index'

import { getProtocolContent } from '../home/protocol'

let isInit = true
const DO_NOT_USE_COUPON = 'no'

// 获取选择人数列表
function getPassengerPickerData({ userNum }) {
  function getList(len) {
    const list = []
    for (let i = 1; i <= len; i++) {
      list.push({
        label: i + '人',
        value: i
      })
    }
    return list
  }
  return getList(userNum)
}

export default {
  name: 'makeupTicket',
  components: {
    NavBar,
    ProtocolSelector,
    BusSelector,
    PassengerSelector,
    CashCardPopup,
    CashCard
  },
  data() {
    return {
      passengerIndex: 0,
      busIndex: 0,
      ordering: false,
      isProtocol: false,
      isLoading: false,
      userPos: null, // 当前用户位置
      nearInfo: null, // 通过定位获取的附近区域和站点等信息
      isFromPoiOrChoose: false, // 是否地图选点返回来的
      isFromQr: false, // 是否扫码进入的
      couponList: [], // 可用优惠劵列表
      cashParams: {
        selectedCouponId: null, // 选择的优惠劵id
        actualPrice: 0, // 未计算优惠劵前的实际价格
      },
      cashCardVisible: false,
      queryBusId: null,
    }
  },
  computed: {
    ...mapGetters({
      areas: 'run/areas',
      dataUserPos: 'dataUserPos',
      areaId: 'home/areaId',
      offStop: 'dataOffStop',
      currentAreaPriceList: 'run/currentAreaPriceList',
      currentArea: 'run/currentArea',
      isDefaultAreaLoaded: 'run/isDefaultAreaLoaded',
      ticketConfig: "config/ticketConfig",
    }),
    baseLineId() {
      const { baseLineId='' } = this.nearInfo || {}
      return baseLineId
    },
    baseLineName() {
      const { baseLineName } = this.nearInfo || {}
            return baseLineName
    },
    busInfoList() {
      const { busInfoList } = this.nearInfo || {}
      return busInfoList || []
    },
    busList() {
      if (!this.busInfoList || !this.busInfoList.length) return []
      return this.busInfoList.map(item => {
        return {
          label: item.busLicense,
          value: item.busId
        }
      })
    },
    busId() {
      if (this.queryBusId) {
        return this.queryBusId
      }
      const { value } = this.busList[this.busIndex] || {}
      return value
    },
    // 当前选中的车牌号
    busLicense() {
      const arr = this.busInfoList.filter(
        item => item.busId + '' === this.busId + '' && this.busId
      )
      return arr && arr.length ? arr[0].busLicense : undefined
    },
    onStopId() {
      const { stopId } = this.nearInfo || {}
      return stopId
    },
    onStopName() {
      const { name } = this.nearInfo || {}
      return name
    },

    offStopId() {
      const { id } = this.offStop || {}
      return id
    },
    offStopName() {
      const { name } = this.offStop || {}
      return name || '输入您的目的地'
    },
    cityId() {
      return this.$AppService.getCityId()
    },
    userId() {
      return this.$UserService.getUserId()
    },
    passengerPickerData() {
      let {userNum} = this.currentArea || {}
      const res = [
        ...getPassengerPickerData({userNum: userNum || 1})
      ]
      return res
    },
    // 是否选中包车
    isChartered() {
      return false
    },
    passengerCount() {
      const { value } = this.passengerPickerData[this.passengerIndex] || {};
      return value;
    },
  },
  watch: {
    dataUserPos: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.length) {
          const [lng, lat] = val || []
          const marsPos = baiduToMars(lng, lat) || {}
          if (
            !this.nearInfo &&
            !this.isLoading &&
            this.$UserService.isUserLogin()
          ) {
            this.isLoading = true
            getConfig({ cityId: this.cityId }).then(res => {
              const { suppleTicket } = res || {}
              if (suppleTicket === 0) {
                this.requestNearStopAndBus({
                  lat: marsPos.lat,
                  lng: marsPos.lng,
                  userId: this.userId,
                  cityId: this.cityId
                }).finally(() => {
                  this.isLoading = false
                  Toast.clear()
                })
              }
            })
          } else {
            Toast.clear()
          }
        }
      }
    },

    ordering: {
      immediate: true,
      handler(ordering) {
        if (ordering) {
          Toast.loading({
            message: '正在下单',
            duration: 0,
            forbidClick: true
          })
        } else {
          Toast.clear()
        }
      }
    },
    // areas: {
    //   immediate: true,
    //   handler(areas) {
    //     if (areas && areas.length) {
    //       const res = this.nearInfo
    //       const currentAreaIndex = this.areas.findIndex(
    //         item => item.id === res.baseLineId && res.baseLineId
    //       )
    //       console.log('here-areas', this.areas)
    //       console.log('here-currentAreaIndex', currentAreaIndex)
    //       if (currentAreaIndex > -1) {
    //         setTimeout(() => {
    //           this.$RunService.setCurrentArea(currentAreaIndex)
    //         }, 1000)
    //       }
    //     }
    //   }
    // },
    isDefaultAreaLoaded: {
      immediate: true,
      handler(val) {
        console.log('isDefaultAreaLoaded', val, this.nearInfo)
        if (val) {
          const areas = this.areas
          if (areas && areas.length) {
            const res = this.nearInfo
            if (!res) return
            const currentAreaIndex = this.areas.findIndex(
              item => item.id === res.baseLineId && res.baseLineId
            )
            if (currentAreaIndex > -1) {
              this.$RunService.setCurrentArea(currentAreaIndex)
            }
          }
        }
      }
    }
  },
  activated() {
    const cityId = getUrlParams('cityId')
    const busId = getUrlParams('busId')
    if (cityId) {
      this.$AppService.setCityId(cityId)
    }
    this.isFromQr = !!busId
    // 微信授权跳转到这页面时，把#置换成参数了。这里置换回来
    const href = window.location.href
    const hrefSearch = window.location.search
    if (hrefSearch && this.$UserService.isUserLogin()) {
      const arr = href.split(hrefSearch)

      setTimeout(() => {
        window.location.href = `${arr[0]}#/makeup-ticket?cityId=${cityId}&busId=${busId}`
      }, 300)
    }
    // 关闭地图
    this.$MapService.setStateMapVisible(false)

    // 设置busId和定位loading
    if (!this.isFromPoiOrChoose) {
      const query = this.$route.query || {}
      this.queryBusId = query.busId
      if (this.$UserService.isUserLogin() && !this.nearInfo) {
        getConfig({ cityId: this.cityId }).then(res => {
          const { suppleTicket } = res || {}
          if (suppleTicket === 0) {
            Toast.loading({
              message: '定位中...',
              duration: 0,
              forbidClick: true
            })
          }
          if (suppleTicket === 1) {
            this.requestNearStopAndBus({
              userId: this.userId,
              cityId: this.cityId,
              busId: this.busId
            })
          }
        })
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    const { name, params } = from || {}
    if (name !== 'Poi') {
      if (name === 'choose') {
        const { couponId } = params || {}
        next(vm => {
          vm.isFromPoiOrChoose = true
          vm.cashCardVisible = true
          setTimeout(() => {
            vm.cashParams = {
              ...vm.cashParams,
              selectedCouponId: couponId || null
            }
          })
        })
      } else {
        next(vm => {
          vm.isFromPoiOrChoose = false
          vm.nearInfo = null
          vm.$MapService.setMapDataOffStop(null)
        })
      }
    } else {
      next(vm => {
        vm.isFromPoiOrChoose = true
      })
    }
  },
  methods: {
    requestNearStopAndBus(params) {
      return getNearStopAndBus(params)
        .then(res => {
          this.nearInfo = res
          const currentAreaIndex = this.areas.findIndex(
            item => item.id === res.baseLineId && res.baseLineId
          )
                    if (currentAreaIndex > -1) {
            this.$RunService.setCurrentArea(currentAreaIndex)
          }
        })
        .catch(err => {
          console.log('requestNearStopAndBus err: ', err)
          if (isInit) {
            isInit = false
            this.$toast(err.msg || '未获得推荐站点')
          }
        })
    },
    // 请求获取可用优惠劵
    requestValidCoupons(price) {
      return getValidCoupons({
        bigCityId: this.cityId,
        cityId: this.cityId,
        userId: this.userId,
        lineId: this.baseLineId,
        price
      }).then(res => {
        console.log('getValidCoupons res:', res)
        this.couponList = res || []
        if (res && res.length) {
          this.cashParams = {
            ...this.cashParams,
            selectedCouponId: res[0].couponId
          }
          return Promise.resolve(res)
        } else {
          this.cashParams = {
            ...this.cashParams,
            selectedCouponId: null
          }
          return Promise.reject()
        }
      })
    },
    getProtocol() {
      const cityId = this.$AppService.getCityId()
      return getProtocolContent(cityId)
    },
    // 选择下车点
    onOffPoiClick() {
      if (!this.baseLineId) return
      if (!this.$UserService.isUserLogin()) {
        this.$UserService.turnToLoginView()
        return
      }
      if (!this.onStopId) {
        this.$toast('请先选择上车站')
        return
      }
      this.$PoiService.setStopTypeOff()
      this.$nextTick(() => {
        this.$PoiService.turnToPoiView(
          {
            from: 'makeupTicket'
          },
          { type: 'off', areaId: this.baseLineId, disabledMap: 1 }
        )
      })
    },
    // 选择车辆
    onBusOk(index) {
      this.busIndex = index
    },
    // 选择人数
    onPassengerOk(index) {
      this.passengerIndex = index;
    },
    onClickSubmitDisabled() {
      this.$toast('请先阅读并同意下方协议')
    },
    onClickSubmit() {
      if (!this.$UserService.isUserLogin()) {
        this.$UserService.turnToLoginView()
        return
      }
      if (!this.baseLineId) {
        this.$toast({
          message: '暂无可用区域'
        })
        return
      }
      if (!this.busId) {
        this.$toast({
          message: '请选择车辆'
        })
        return
      }
      if (!this.onStopId) {
        this.$toast({
          message: '暂无可用站点'
        })
        return
      }
      if (!this.offStopId) {
        this.$toast({
          message: '请选择下站点'
        })
        return
      }

      if (this.onStopId === this.offStopId) {
        this.$cheToast({
          type: "fail",
          text: "该站点已被选为上车站，请重新选择",
          timeout: 3000
        });
        // Toast.fail({
        //   message: '该站点已被选为上车站，请重新选择',
        //   duration: 3000
        // })
        return
      }
      if (!this.ordering) {
        this.ordering = true
        const { reactiveBaseLine } = this.nearInfo || {}
        const { reactiveLineStops } = reactiveBaseLine || {}
        const { id } = this.currentArea || {};
        const stops = (reactiveLineStops || [])
          .filter(p => !!p)
          .map(stop => {
            const {
              id,
              lng,
              lat,
              name,
              price,
              reactiveLineStopSectionTickets = []
            } = stop || {}
            const { lng: _lng, lat: _lat } = marsToBaidu(lng, lat)
            return {
              id,
              lng: _lng,
              lat: _lat,
              name,
              price,
              priceList: (reactiveLineStopSectionTickets || []).map(o => {
                let { orderNum: level, price, singalNum: num } = o || {}
                return {
                  level,
                  price,
                  num
                }
              })
            }
          })
        const onStopArr = stops.filter(stop => stop.id === this.onStopId)
        const onStop = onStopArr && onStopArr.length ? onStopArr[0] : null
        const offStopArr = stops.filter(stop => stop.id === this.offStopId)
        const offStop = offStopArr && offStopArr.length ? offStopArr[0] : null
        this.$HomeService.fetchPrice({
					baseLineId: id,
					onStopId: onStop ? onStop.id: null,
					onStopName: onStop ? onStop.name: null,
					offStopId: offStop ? offStop.id: null,
					offStopName: offStop ? offStop.name: null,
          ticketNum: this.passengerCount,
					userId: this.$UserService.getUserId(),
          payType: getPayType().id
        }, this).then(({ originPrice, actualPrice }) => {
          console.log('ladderPrice', actualPrice, originPrice)
          let params = {
            baseLineId: this.baseLineId,
            busId: this.busId,
            onStopId: this.onStopId,
            onStopName: this.onStopName,
            offStopId: this.offStopId,
            offStopName: this.offStopName,
            payType: getPayType().id,
            singalNum: this.passengerCount, //  乘客数量
            ticketPrice: originPrice, // 原价
            sessionId: this.$UserService.getSessionId(),
            mobile: this.$UserService.getUserMobile(),
            actualPrice
          }
					const [userLng, userLat] = this.dataUserPos || []
					if (userLng && userLat) {
						const marsPos = baiduToMars(userLng, userLat) || {};
						params.lng = marsPos.lng;
						params.lat = marsPos.lat;
					}
          const isServiceManager = this.$UserService.isServiceManager()
          const supportAreaIds = this.$UserService.getSupportAreaIds() || []
          const isServiceOrder = isServiceManager && supportAreaIds.includes(this.baseLineId) // 客服机
          const isZeroPay = typeof actualPrice === 'number' && actualPrice <= 0
          if (isServiceOrder || isZeroPay || this.isChartered) {
            this.handleOrder(params)
          } else {
            this.checkOrder(params)
          }
        }).catch((error) => {
          console.log('fetchPrice error:', error)
					const { msg } = typeof error === 'object' && error ? error: {}
					this.ordering = false
					this.cashCardVisible = false
          this.$cheToast({
            type: "fail",
            text: msg || '下单失败',
            timeout: 3000
          });
          // Toast.fail({
          //   message: msg || '下单失败',
          //   duration: 3000
          // })
				})
      }
    },
    // 下单前进行校验：当前有可用优惠劵，需要弹框；没有可用优惠劵，直接下单
    checkOrder(params) {
      const { actualPrice } = params || {}
      // 有可用优惠劵，先弹框选劵
      this.requestValidCoupons(actualPrice)
        .then(() => {
          this.ordering = false
          this.orderParams = params
          const data = { ...this.cashParams }
          this.cashParams = null
          setTimeout(() => {
            this.cashParams = {
              ...data,
						  ...deepCopy(params)
            }
          }, 10)
          this.cashCardVisible = true
        })
        .catch(() => {
          // 没有可用优惠劵，直接下单
          this.handleOrder(params)
        })
    },
    // 处理下单
    handleOrder(params = {}) {
      // 包车不支持优惠劵
      if (this.isChartered) {
        delete params.couponId
      }
      this.ordering = true
      this.$AppService
        .supplyOrder(params)
        .then(res => {
          this.$AppService.setWxPayInfo(res)
          this.setDefaultPassenger()
          wait(500).then(() => {
            this.$OrderService.turnToOrderPay(
              {
                from: 'makeupTicket'
              },
              {
                ticketInfoId: this.$AppService.getTicketInfoId()
              }
            )
          })
          this.ordering = false
          this.cashCardVisible = false
          this.clearOrderCache()
        })
        .catch(res => {
          console.error('supplyOrder error:', res)
          this.ordering = false
          this.$nextTick(() => {
            this.$cheToast({
              type: "fail",
              text: res.msg || res.errmsg,
              timeout: 3000
            });
            // Toast.fail({
            //   message: res.msg || res.errmsg,
            //   duration: 3000
            // })
          })
        })
    },
    // 下单成功后，清理下单前的缓存数据
    clearOrderCache() {
      this.orderParams = null
      this.cashParams = {
        selectedCouponId: null,
        actualPrice: 0
      }
    },
    // 去往选择优惠劵页面
    onChooseCoupon() {
      if (this.$UserService.isUserLogin()) {
        const params = this.cashParams.selectedCouponId
          ? {
              couponId: this.cashParams.selectedCouponId
            }
          : {}
        const query = {
          areaId: this.baseLineId,
          price: this.cashParams.actualPrice
        }
        this.$router.push({ name: 'choose', params, query })
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    // 确认下单
    onConfirmOrder(data) {
      const { couponId, actualPrice } = data || {}
      if (couponId && couponId !== DO_NOT_USE_COUPON) {
        this.orderParams.couponId = couponId
      } else {
        delete this.orderParams.couponId
      }
      if (actualPrice || actualPrice === 0) {
        this.orderParams.actualPrice = actualPrice
      }
      this.handleOrder(this.orderParams)
    },
		// 使用优惠劵失败
		useCouponFail() {
			if (this.cashParams) {
				this.cashParams = {
					...this.cashParams,
					selectedCouponId: DO_NOT_USE_COUPON
				}
			}
		},
    // 设置默认的乘车人数
    setDefaultPassenger() {
      this.passengerIndex = 0;
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  background: #F3F4F5;
}

.tip {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FE5959;
  line-height: 20px;
  padding: 8px 16px;
  background: #FEE5E5;
}

.box {
  background: #FFFFFF;
  border-radius: 12px;
  margin: 10px;
  padding: 10px 14px;
}

.item {
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  width: 94px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
}

.right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  overflow: hidden;
}
.name {
  flex: 1;
  text-align: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gray {
  color: #999999 !important;
}
.gray2 {
  color: rgba(0,0,0,0.6) !important;
}
.arrow {
  width: 5px;
  height: 9px;
  margin-left: 8px;
}

.bottom {
  padding: 0 10px;
}
.submit {
  width: 100%;
  height: 48px;
  border-radius: 25px;
  background: linear-gradient(90deg, #00A7FD 0%, #006EFA 100%);
  box-shadow: 0px 2px 8px 0px #5A85B9;
  border: none;
  opacity: 0.9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.disabled {
  opacity: 0.5;
}
</style>
